mod.modules.define("BaseScreenerPage", function(fn) {

    fn.prototype.init = function (params) {

		// Track which issueIds have been removed
		this.excludedIssueIds = {};

	    this.pageSize = params.pageSize || 50;


		// Set up the initial user's custom columns
		this.customColumns = params.customColumns || [];

		// Set up the list of columns that are always included
		this.defaultColumns = params.defaultColumns || [];

		// Set the default sort
		if (params.defaultSortSafeName) {
			this.defaultSortSafeName = params.defaultSortSafeName;
		}

		// Add the plugin that will launch the customize columns modal
		if (params.customColumnsId) {
			this.CustomColumnsPlugin = this.addPlugin("Plugin-CustomColumns", {
				tableId: params.customColumnsId,
				maxColumns: params.maxColumns || 5
			});
		}

		// Capture the safe name for the wsodIssue field
		if (params.wsodIssueSafeName) {
			this.wsodIssueSafeName = params.wsodIssueSafeName;
		}

    	// Init the tooltips
		this.el.find("span.icon-pdf.off[rel=tooltip]").tooltip({
			maxWidth: 215
		});
	};

	fn.prototype.initScreener = function() {
		var self = this;
		var isPreScreening = false;
		var isScreening = false;

		// Step 1
		this.ScreenerUtilNamespace = (typeof (WSOD.ScreenerUtility) == "undefined") ? window : WSOD;
		this.ScreenerUtilityInstance = this.ScreenerUtilNamespace.ScreenerUtility.CreateInstance();
		this.ScreenerInputs = new this.ScreenerUtilNamespace.ScreenerUtility.ScreenInputs();

		// Setup the paging inputs
		this.ScreenerInputs.SetFirstRow(0);
		this.ScreenerInputs.SetRowCount(this.pageSize);

		// Set the id
		var screenerId = this.el.attr("data-screenerid");
		this.ScreenerInputs.SetScreenerID(screenerId);

		// Set sorting
		this.resetSorting();

		function stopScreening(type) {
			if (type == "prescreen") {
				isPreScreening = false;
			}

			if (type == "screen") {
				isScreening = false;
			}

			// Only stop if both are finished
			if (!isPreScreening && !isScreening) {
				self.hideLoading();
			}
		}

		function startScreening(type) {
			if (type == "prescreen") {
				isPreScreening = true;
			}

			if (type == "screen") {
				isScreening = true;
			}

			self.showLoading();
		}

		this.ScreenerUtilityInstance
			// Register Screen
			.SetScreenURL("~/Screener/DoScreen")
			.SetInputs(this.ScreenerInputs)
			.OnBeforeScreen("ShowLoader", function() { startScreening("screen"); })
			.OnScreenComplete("HideLoader", function() { stopScreening("screen"); })
			.OnScreenSuccess("ShowResults", $.proxy(this.screenRequestCallback, this))
			// Register prescreen
			.SetPreScreenURL("~/Screener/DoPreScreen")
			.OnBeforePreScreen("ShowLoader", function() { startScreening("prescreen"); })
			.OnPreScreenComplete("HideLoader", function() { stopScreening("prescreen"); })
			.OnPreScreenSuccess("ShowResults", $.proxy(this.preScreenRequestCallback, this));
	};

	fn.prototype.screenRequestCallback = function(response) {
		if (response && response.resultTable) {
			var $response = $(response.resultTable);
			var $wrapper = $('div.table-wrapper').empty();

			// Add the header
			$wrapper.append(
				$response.find('div.screener-results-header')
			);

			// Make the new composite tables
			$response.find('table').fixedTable({
				container: $wrapper,
				numColumns: 2
			});
		}

		if (this.activeTab === "custom") {
		    $("div.screener-results-header button[data-action='customize-columns']").show();
		    $("div.custom-tab-display-options").show();
		    $("div:not('.custom-tab-display-options') > .num-results-per-page").hide();
		}
		else {
		    $("div.screener-results-header button[data-action='customize-columns']").hide();
		    $("div.custom-tab-display-options").hide();
		    $("div:not('.custom-tab-display-options') > .num-results-per-page").show();
		}
	};

	fn.prototype.preScreenRequestCallback = function(response) { };

	fn.prototype.buildScreenInputs = function(resultFields) {
		// Clear out the old arguments
		this.ScreenerInputs.RemoveArguments();

		this.ScreenerInputs.SetResultFields(resultFields);
	};

	fn.prototype.addExcludedIssueIdArgs = function(excludedIssueIds) {
		// Add the excluded issueIds
		for (var issueId in excludedIssueIds) {
			var argument = new ScreenerUtility.Argument();
			argument.SetField(this.wsodIssueSafeName);
			argument.SetSafeName(this.wsodIssueSafeName);
			argument.AddClause(
				new ScreenerUtility.Argument.Clause(ScreenerUtility.OPERATORS.NotEqualTo, [issueId])
			);
			this.ScreenerInputs.AddArgument(argument);
		}
	};

	// --------------------------------------------------------------------------
	// Actions
	// --------------------------------------------------------------------------

	fn.prototype.addToWatchlist = function(watchlistId, issueIds) {
		if (watchlistId && issueIds && issueIds.length) {
			$.ajax({
				url: "AddToWatchlist",
				dataType: "json",
				traditional: true,
				data: {
					watchlistId: watchlistId,
					issueIds: issueIds
				},
				cache: false,
				context: this,
				success: function(response) {
					if (response && response.status) {
					}
				},
				error: function error() {
					this.logError("Could not add to watchlist");
				},
				beforeSend: function() {
					this.showLoading();
				},
				complete: function() {
					this.hideLoading();
				}
			});
		}
	};

	// Remove the specified rows from the results table
	fn.prototype.removeFromResults = function(issueIds) {
		if (issueIds && issueIds.length) {
			for (var i = 0; i < issueIds.length; i++) {
				this.excludedIssueIds[issueIds[i]] = true;
			}

			// Run the screen and pass it the new argument
			this.runScreen();
		}
	};

	// Remove the specified rows from the results table
	fn.prototype.restoreRemovedResults = function() {
		if (this.excludedIssueIds && Object.keys(this.excludedIssueIds).length) {
			this.excludedIssueIds = {};
			this.runScreen();
		}
	};

	fn.prototype.downloadResults = function (type, callback) {

		this.buildScreenInputs();
		var inputString = JSON.stringify(this.ScreenerUtilityInstance.GetInputs(true));

		var $form = $("#postingForm");
		$form.find("input[name=inputs]").val(inputString);
		$form.find("input[name=type]").val(type);
		$form.submit();

		if (callback) {
			callback();
		}
	};

	// --------------------------------------------------------------------------
	// Utils
	// --------------------------------------------------------------------------

	fn.prototype.resetPaging = function() {
		this.ScreenerInputs.SetFirstRow(0);
		this.ScreenerInputs.SetRowCount(this.pageSize);
	};

	fn.prototype.resetSorting = function(newSortSafeName, newSortDir) {
		newSortSafeName = newSortSafeName || this.defaultSortSafeName;
		newSortDir = newSortDir || 'Ascending';

		if (newSortSafeName) {
			// Remove the previous args
			this.ScreenerInputs.RemoveSortArguments();

			this.ScreenerInputs.AddSortArgument(
				new this.ScreenerUtilNamespace.ScreenerUtility.ScreenInputs.SortArgument(
					newSortSafeName,
					ScreenerUtility.SORT_DIRECTION[newSortDir]
				)
			);
		}
	};

	fn.prototype.showLoading = function() {
		this.$screenerContent.addClass("loading");
	};

	fn.prototype.hideLoading = function() {
		this.$screenerContent.removeClass("loading");
	};

	//VL-276 this handler deals with the API check
	fn.prototype.handlePDFClickResult = function (response, status, request) {
		if (response) {
			if (/true/i.test(response.success)) {
				var docURL = response.message;
				if (docURL != null && docURL != "") {
					docURL = docURL.resolveUrl();

					if (docURL.indexOf("secure/secure") > 0) {
						docURL = docURL.replace("secure/secure", "secure");
					}
				}

				window.open(docURL, "_blank");
			} else {
				alert(response.message);
			}
		} else {
			alert("Sorry, something went wrong with your document request.");
		}
	};

	// --------------------------------------------------------------------------
	// Events
	// --------------------------------------------------------------------------

    fn.prototype.events = {
		// --------------------
		// Paging/sorting
	    // --------------------
    	".num-results-selector": {
    		"change": function (e, $el) {
                this.pageSize = $el.val();
                this.ScreenerInputs.SetRowCount(this.pageSize);
                this.runScreen();
            }
        },

		"[data-sortfield]": {
			"click": function(e, $el) {
				var field = $el.attr("data-sortfield");
				var direction = $el.attr("data-sortdir") || "desc";

				// Convert the direction to something the Screen lib will understand
				// NOTE: remember that we're reversing the direction at this point
				var serverDirection = direction == "asc" ? "Descending" : "Ascending";

				this.resetSorting(field, serverDirection);

				// Go back to page 1
				this.resetPaging();

				// Re-run the screen
				this.runScreen();
			}
		},
		".pager-wrap a[data-pageindex]:not([disabled])": {
			"click": function(e, $el) {
				var index = parseInt($el.attr("data-pageindex"), 10);
				// Update the screener inputs then make the call
				this.ScreenerInputs.SetFirstRow(this.pageSize * index);
				this.runScreen();
			}
		},
		".pager-select-page": {
			"change": function(e, $el) {
				var index = parseInt($el.val(), 10);
				// Update the screener inputs then make the call
				this.ScreenerInputs.SetFirstRow(this.pageSize * index);
				this.runScreen();
			}
		},
		// --------------------
		// Action Buttons
		// --------------------
		"[data-action=download-data]": {
			"click": function(e, $el) {
				$("#screener_download").modal();
			}
		},
		"[data-action=download-screen]": {
		    "click": function (e, $el) {
				var $modal = $el.closest('div.modal-body');
				var $selectedInput = $modal.find('div.config-section input:checked');
				var selectedType = $selectedInput.val();

				// Kick off the download
				this.downloadResults(selectedType, function() {
					$("#screener_download").modal("hide");
				});
			}
		},
		"[data-action=customize-columns]": {
			"click": function(e, $el) {
				this.CustomColumnsPlugin.showModal();
			}
		},
		"select.action-switcher": {
			"change": function(e, $el) {
				var val = $el.val();

				if (val) {
					var $checkedInputs = this.$screenerContainer.find("div.table-wrapper td input.row-selector:checked");
					var issueIds = $checkedInputs.map(function(i, input) {
						return input.getAttribute("data-id");
					}).get();

					if (val === "cmd-remove") {
						this.removeFromResults(issueIds);
					} else if (val == "cmd-restore") {
						this.restoreRemovedResults();
					}
					else if (val.indexOf("cmd-addtowatchlist") != -1) {
						var watchlistId = val.replace("cmd-addtowatchlist:", "");
						this.addToWatchlist(watchlistId, issueIds);

						// Reset the selected index to 0
						$el.val("");
					}
				}
			}
		},
		// --------------------
		// Result Table Actions
		// --------------------
		"input.table-selector": {
			"click": function(e, $el) {
				var isChecked = $el.is(":checked");
				$el.closest("table").find("tbody input:checkbox").prop("checked", isChecked);
			}
		},
		// --------------------
		// Tabs
		// --------------------
		".screener-results-table a[data-toggle='tab']:not(.active a)": {
			"click": function(e, $el) {
				var self = this;
				var fieldsJson = $el.attr("data-fields");

				// Show or hide the "customize columns" button
				if ($el.attr("id") === "tab-custom") {
					this.activeTab = "custom";
				}
				else {
					this.activeTab = null;
				}

				// See if the tab has any attached fields
				if (!fieldsJson) {
					// Must be a group tab
					var $target = $($el.attr("data-target"));
					fieldsJson = $target.find("select").val();
				}

				// Kick the screen event on the main loop so the button can toggle its state
				setTimeout(function() {
					var fields = JSON.parse(fieldsJson);

					// Update the active fields
					self.runScreen(fields);
				}, 0);
			}
		},
		"select.sub-field-switcher": {
			"change": function(e, $el) {
				var fields = JSON.parse($el.val());
				this.runScreen(fields);
			}
		},
    	//VL-276 added for handling our PDF links.
		"a.industryReportPDF, a.stockReportPDF": {
			"click": function (e, $el) {
				var $target = $(e.target);
				if ($target.is("A") == false) {
					$target = $target.closest("A")
				}
				var apiURL = $target.attr("api");
				var docType = $target.attr("docType");
				var item = $target.attr("item");

				if (apiURL != null && apiURL != "") {
					apiURL = apiURL.resolveUrl();

					if (apiURL.indexOf("secure/secure") > 0) {
						apiURL = apiURL.replace("secure/secure", "secure");
					}
				}

				var postData = {
					itemQuery: item,
					docType: docType
				};
				
				$.ajax({
					url: apiURL,
					type: "post",
					dataType: "json",
					data: postData,
					context: this,
					success: $.proxy(this.handlePDFClickResult, this),
					error: function error() {
						alert("There was an error when trying to get your document.");
					}
				});
			}
		}
	};

});